/* ============================= */
/* FHG CART DRAWER – JS FINAL    */
/* (atualiza mesmo com outros JS)*/
/* ============================= */

(() => {
  // evita duplo binding
  if (window.__FHG_CART_DRAWER_INIT__) return;
  window.__FHG_CART_DRAWER_INIT__ = true;

  const SELECTORS = {
    drawer: "#CartDrawer",
    overlay: "#CartDrawerOverlay",
    itemsBox: "#CartDrawerItems",
    subtotal: "#CartDrawerSubtotal",
    bubble: "#cart-icon-bubble",
    closeBtn: ".cart-drawer__close",
  };

  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const getDrawer = () => qs(SELECTORS.drawer);
  const getOverlay = () => qs(SELECTORS.overlay);
  const getItemsBox = () => qs(SELECTORS.itemsBox);
  const getSubtotal = () => qs(SELECTORS.subtotal);
  const getBubble = () => qs(SELECTORS.bubble);

  const formatMoney = (cents) => {
    // tenta Shopify.formatMoney se existir
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        // usa o format do tema se existir
        const fmt =
          (window.theme && window.theme.moneyFormat) ||
          (window.Shopify && window.Shopify.money_format) ||
          "{{amount_with_comma_separator}}";
        return window.Shopify.formatMoney(cents, fmt);
      }
    } catch (e) {}
    // fallback BRL
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format((cents || 0) / 100);
  };

  const openDrawerUI = () => {
    const drawer = getDrawer();
    const overlay = getOverlay();
    if (!drawer || !overlay) return;

    drawer.classList.add("is-open");
    overlay.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");

    // trava scroll body
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  };

  const closeDrawerUI = () => {
    const drawer = getDrawer();
    const overlay = getOverlay();
    if (!drawer || !overlay) return;

    drawer.classList.remove("is-open");
    overlay.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");

    // destrava scroll
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  };

  const fetchCart = async () => {
    const res = await fetch("/cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
    if (!res.ok) throw new Error("Falha ao buscar /cart.js");
    return await res.json();
  };

  const renderCart = (cart) => {
    const box = getItemsBox();
    const subtotalEl = getSubtotal();
    const bubble = getBubble();

    if (bubble) bubble.textContent = String(cart?.item_count || 0);
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart?.total_price || 0);

    if (!box) return;

    // garante que o container (UL do snippet) recebe LIs diretamente (sem UL dentro)
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      box.innerHTML = `<li class="fhg-cart-item"><p style="margin:0;font-weight:700;">Seu carrinho está vazio</p></li>`;
      return;
    }

    const html = cart.items
      .map((it) => {
        const title = (it.product_title || "").trim();
        const variant =
          it.variant_title && it.variant_title !== "Default Title"
            ? it.variant_title
            : "";
        const img = it.image
          ? `<div class="fhg-cart-media"><img src="${it.image}" alt="${escapeHtml(
              title
            )}" loading="lazy"></div>`
          : `<div class="fhg-cart-media"></div>`;

        return `
          <li class="fhg-cart-item" data-line="${it.line}">
            <div class="fhg-cart-row">
              ${img}
              <div class="fhg-cart-info">
                <p class="fhg-cart-title">${escapeHtml(title)}</p>
                ${
                  variant
                    ? `<p class="fhg-cart-variant">${escapeHtml(variant)}</p>`
                    : ""
                }
                <div class="fhg-cart-meta">
                  <span class="fhg-cart-qty">Qtd: ${it.quantity}</span>
                  <strong class="fhg-cart-price">${formatMoney(
                    it.final_line_price
                  )}</strong>
                </div>
              </div>
            </div>
          </li>
        `;
      })
      .join("");

    box.innerHTML = html;
  };

  const escapeHtml = (str) => {
    return String(str || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  };

  const refreshDrawer = async () => {
    try {
      const cart = await fetchCart();
      renderCart(cart);
      return cart;
    } catch (e) {
      // não quebra o site se falhar
      // eslint-disable-next-line no-console
      console.warn("[FHG CartDrawer] refresh falhou:", e);
      return null;
    }
  };

  // expõe função global usada no seu header: onclick="openCartDrawer()"
  window.openCartDrawer = async () => {
    await refreshDrawer();
    openDrawerUI();
  };

  // fechar drawer
  const bindClose = () => {
    const overlay = getOverlay();
    if (overlay) {
      overlay.addEventListener("click", closeDrawerUI);
    }

    qsa(SELECTORS.closeBtn).forEach((btn) => {
      btn.addEventListener("click", closeDrawerUI);
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeDrawerUI();
    });
  };

  // =============================
  // ATUALIZA MESMO COM OUTROS JS
  // intercepta fetch para /cart/*
  // =============================
  const patchFetch = () => {
    if (window.__FHG_CART_FETCH_PATCHED__) return;
    window.__FHG_CART_FETCH_PATCHED__ = true;

    const originalFetch = window.fetch.bind(window);

    window.fetch = async (...args) => {
      const res = await originalFetch(...args);

      try {
        const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
        const isCartMutation =
          url.includes("/cart/add") ||
          url.includes("/cart/change") ||
          url.includes("/cart/update") ||
          url.includes("/cart/clear");

        if (isCartMutation) {
          // pequena folga para evitar corrida com scripts do tema
          setTimeout(() => {
            refreshDrawer();
          }, 50);
        }
      } catch (e) {}

      return res;
    };
  };

  // init
  const init = () => {
    bindClose();
    patchFetch();

    // opcional: se abrir drawer e já existir item renderizado por Liquid,
    // ainda assim garantimos consistência:
    refreshDrawer();
  };

  // DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
// =============================
// BLOQUEIA CARRINHO PADRÃO DO TEMA
// =============================
document.addEventListener("click", (e) => {
  const cartLink = e.target.closest('a[href="/cart"], a[href="/cart/"]');

  if (!cartLink) return;

  // impede navegação padrão
  e.preventDefault();
  e.stopPropagation();

  // abre o drawer
  if (typeof window.openCartDrawer === "function") {
    window.openCartDrawer();
  }
});
